interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}>
      <div
        className={`flex items-center gap-3 ${isCenter ? "justify-center" : ""}`}
      >
        <span className="h-px w-8 bg-accent-500" />
        <span className="font-label text-xs tracking-[0.35em] text-primary-600 uppercase">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-4 font-heading text-2xl md:text-3xl lg:text-4xl font-bold leading-snug text-foreground-950">
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
          {desc}
        </p>
      )}
    </div>
  );
}